// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161135/js/" + chunkId + "." + {"44":"91b154d9","225":"34fecc7f","481":"1dafc0cb","486":"7805e684","770":"4565f4d0"}[chunkId] + ".0.8164204479861066.chunk.js";
};